/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var ActivityDescriptionStatus;

(function (ActivityDescriptionStatus) {
  ActivityDescriptionStatus["PENDING"] = "pending";
  ActivityDescriptionStatus["APPROVED"] = "approved";
})(ActivityDescriptionStatus || (ActivityDescriptionStatus = {}));